import { peek, selector } from 'lib/selectors'
import { LocationType, StateInterface } from 'types/state'

const location = (state: StateInterface) => state.location
export const countriesSelector = selector(location, peek('countries'))
export const citiesSelector = selector(location, (e: LocationType) => e.get('cities'))
export const phoneCodesSelector = selector(location, (e: LocationType) => e.get('phoneCodes'))
